import { trackAndTraceRepo } from "./trackAndTrace.repo";
import {
  ISastavPakovanjaIstorija,
  ITtIstorijaKodaPayload,
  IzvestajiOPrometuPayload,
  MonitoringListFilterPayload,
  TrackingListFilterPayload,
} from "./trackAndTrace.types";

class TrackAndTraceService {
  postTtIstorijaKoda = (payload: ITtIstorijaKodaPayload) => {
    return trackAndTraceRepo.postTtIstorijaKoda(payload);
  };

  postTtIstorijaKodaSastav = (payload: ISastavPakovanjaIstorija) => {
    return trackAndTraceRepo.postTtIstorijaKodaSastav(payload);
  };

  postTtDetaljiIstorije = (id: number, tipPakovanjaId: number) => {
    return trackAndTraceRepo.postTtDetaljiIstorije(id, tipPakovanjaId);
  };

  getTrackingList = (
    payload: Partial<TrackingListFilterPayload | undefined>
  ) => {
    return trackAndTraceRepo.getInicijalnaTabelaZaPracenje(payload);
  };

  getTrackingListFiltersData = () => {
    return trackAndTraceRepo.getInicijalniPodaciZaPracenje();
  };

  postTtPracenjeKodaSastav = (payload: ISastavPakovanjaIstorija) => {
    return trackAndTraceRepo.postTtPracenjeKodaSastav(payload);
  };

  getMonitoringList = (
    payload: Partial<MonitoringListFilterPayload | undefined>
  ) => {
    return trackAndTraceRepo.getMonitoringList(payload);
  };

  getMonitoringDetails = ({ id }: { id: number | null }) => {
    return trackAndTraceRepo.getMonitoringDetails({ id });
  };

  getIzvestajiOPrometu = (payload: IzvestajiOPrometuPayload | undefined) => {
    return trackAndTraceRepo.getIzvestajiOPrometu(payload);
  };
}

export const trackAndTraceService = new TrackAndTraceService();
